import { createFileRoute } from "@tanstack/react-router";

import { calendarEventSearchParamsSchema } from "@/domain/event";
import { ClassroomsScreen } from "@/interactors/ClassroomsScreen";
import { headWithCustomTitle, validateRoutePermission } from "@/utils/router";

export const Route = createFileRoute("/_authed/admin/classrooms/")({
  component: ClassroomsScreen,

  beforeLoad: ({ context }) =>
    validateRoutePermission({
      context,
      action: "read",
      subject: "events",
    }),
  head: () => headWithCustomTitle("main:classrooms.title"),
  validateSearch: calendarEventSearchParamsSchema,
});
